import { Component, OnInit } from '@angular/core';
import { StatisticsService } from '../../statistics/statistics.service';
import { UntypedFormControl } from '@angular/forms';
import { MonthModel } from '../../../shared/components/table/month.model';
import { months, monthsNumeric } from '../../../consts';
import { ActualSelected } from '../../../shared/utils';
import { StatisticsConceptsModel } from '../../statistics/statistics.model';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { chartPalette, gradientFill, tooltipBase, horizontalBarScalesBase, barGeometry } from '../../resume/charts/chart-theme';

@Component({
    selector: 'convfact-concept-statistics',
    templateUrl: './concept-statistics.component.html',
    styleUrls: ['./concept-statistics.component.css'],
    standalone: false
})
export class ConceptStatisticsComponent implements OnInit {

  public statisticsConcepts: StatisticsConceptsModel;

  public monthControl = new UntypedFormControl();
  public monthsSelected: string[];
  public monthList: MonthModel[] = [];
  public allMonthsSelected = false;
  public requestReady = false;

  // ── Conceptos más rentables ──────────────────────────────────
  public chartTypeMostCostEffective: ChartConfiguration<'bar'>['type'] = 'bar';

  public chartDataMostCostEffective: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [{
      data: [],
      label: 'Conceptos más rentables',
      backgroundColor: gradientFill(chartPalette.income),
      hoverBackgroundColor: chartPalette.income,
      ...barGeometry
    }]
  };

  public chartOptionsMostCostEffective: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    animation: { duration: 700, easing: 'easeOutQuart' },
    plugins: { legend: { display: false }, tooltip: tooltipBase() },
    scales: horizontalBarScalesBase(),
  };

  // ── Conceptos más vendidos ───────────────────────────────────
  public chartTypeTopSelling: ChartConfiguration<'bar'>['type'] = 'bar';

  public chartDataTopSelling: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [{
      data: [],
      label: 'Conceptos más vendidos',
      backgroundColor: gradientFill(chartPalette.grant),
      hoverBackgroundColor: chartPalette.grant,
      ...barGeometry
    }]
  };

  public chartOptionsTopSelling: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    animation: { duration: 700, easing: 'easeOutQuart' },
    plugins: { legend: { display: false }, tooltip: tooltipBase() },
    scales: horizontalBarScalesBase(),
  };

  constructor(public statisticsService: StatisticsService, public snackBar: MatSnackBar) {}

  ngOnInit(): void {
    this.setMonths();
    this.loadStatistics();
  }

  public loadStatistics(): void {
    this.requestReady = false;

    this.statisticsService.listMostCostEffectiveConcept()
      .then((response: StatisticsConceptsModel) => {
        this.statisticsConcepts = response;
        this.fillInCharts();
        this.requestReady = true;
      })
      .catch(() => {
        this.displayInfo('Ha ocurrido un error inesperado al cargar las estadísticas');
        this.requestReady = true;
      });
  }

  public fillInCharts(): void {
    this.statisticsConceptsClean();

    // Más rentables
    this.chartDataMostCostEffective = {
      labels: this.statisticsConcepts.mostCostEffectiveConceptsViewModel.map(x => x.conceptName),
      datasets: [{
        data: this.statisticsConcepts.mostCostEffectiveConceptsViewModel.map(x => x.profitMargin),
        label: 'Conceptos más rentables',
        backgroundColor: gradientFill(chartPalette.income),
        hoverBackgroundColor: chartPalette.income,
        ...barGeometry
      }]
    };

    // Más vendidos
    this.chartDataTopSelling = {
      labels: this.statisticsConcepts.topSellingConceptsViewModel.map(x => x.conceptName),
      datasets: [{
        data: this.statisticsConcepts.topSellingConceptsViewModel.map(x => x.totalTimesSold),
        label: 'Conceptos más vendidos',
        backgroundColor: gradientFill(chartPalette.grant),
        hoverBackgroundColor: chartPalette.grant,
        ...barGeometry
      }]
    };
  }

  private statisticsConceptsClean(): void {
    this.statisticsConcepts.mostCostEffectiveConceptsViewModel =
      this.statisticsConcepts.mostCostEffectiveConceptsViewModel.filter(x => x.profitMargin !== 0);
  }

  public setMonths(): void {
    if (this.monthList.length === 0) {
      let i = 1;
      months.forEach(element => {
        const newMonth = new MonthModel();
        newMonth.name = element;
        newMonth.selected = true;
        newMonth.number = i.toString();
        this.monthList.push(newMonth);
        i++;
      });
      this.allMonthsSelected = true;
      this.monthsSelected = monthsNumeric;
      ActualSelected.monthSelectedStatistics = monthsNumeric;
    }
  }

  public onChangeMonth(event): void {
    this.monthsSelected = event.value;
    ActualSelected.monthSelectedStatistics = event.value;
    this.allMonthsSelected = false;
    this.monthList.forEach(el => el.selected = false);
    event.value.forEach(v => {
      const m = this.monthList.find(f => f.number === v);
      if (m) m.selected = true;
    });
    this.loadStatistics();
  }

  public onSelectAll(event): void {
    this.allMonthsSelected = event.checked;
    this.monthsSelected = event.checked ? monthsNumeric : [];
    ActualSelected.monthSelectedStatistics = this.monthsSelected;
    this.monthList.forEach(el => el.selected = event.checked);
    this.loadStatistics();
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container'];
    this.snackBar.open(message, '', options);
  }
  public trackByIndex(i: number) { return i; }

}
